import { getRequestedContent } from './getRequestedContent';
import { PositionType } from '../../enums';
import { messageFactory, Topic } from '../../events';
export const onPlaybackStatus = async (data) => {
    const { content, isPlaying, type } = getRequestedContent();
    if (!content || !isPlaying || !type) {
        return;
    }
    const { id } = content;
    if (typeof data === 'function') {
        const result = await data(id, type);
        data = {
            position: result?.type === PositionType.TIME && "value" in result
                ? result.value
                : undefined,
        };
    }
    const { position, duration } = data;
    if (position === undefined)
        return;
    messageFactory(Topic.PLAYBACK_STATUS, {
        position,
        item: {
            type: "content",
            id,
        },
    });
};
//# sourceMappingURL=onPlaybackStatus.js.map